import axios from "axios";
// NO importamos BudgetStateDto ni AxiosResponse, ya que no hay interfaces.
// const { BudgetStateDto } = require("src/interfaces/budget.interface"); // No usamos require
// const { AxiosResponse } = require("axios"); // No usamos require

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
});

API.interceptors.request.use((config) => {
  const token = localStorage.getItem("Token");
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }
  return config;
});

const budgetService = {
  getBudgetListPaginated: async (params = {}) => { // params sin tipo explícito
    const { data } = await API.get("/budget/", { params });
    return data;
  },

  createBudget: async (budgetData) => { // budgetData sin tipo explícito
    const { data } = await API.post("/budget/", budgetData);
    return data;
  },

  updateBudget: async (budgetId, budgetData) => { // budgetId, budgetData sin tipo explícito
    const { data } = await API.patch(`/budget/${budgetId}/`, budgetData);
    return data;
  },

  deleteBudget: async (budgetId) => { // budgetId sin tipo explícito
    const { data } = await API.delete(`/budget/${budgetId}/`);
    return data;
  },

  renderBudget: async (budgetId) => { // budgetId sin tipo explícito
    const response = await API.get(`/budget-render/${budgetId}/`, {
      responseType: "blob",
    });
    return response.data;
  },

  // Nuevo método para obtener la lista de estados del presupuesto
  getBudgetStateList: async () => { // Sin tipo de retorno explícito
    // Asumo que tu endpoint para los estados es /budget-state/
    const response = await API.get("/budget-state/");
    return response; // Devolvemos la respuesta completa, no solo data
  },

  // getStatusOptions eliminado o renombrado como antes
};

export default budgetService;